// Core React Imports
import React from "react";

// Local Imports
import { usePageFilter } from "./usePageFilter";
import ConstantsImages from "../../constants/ConstantsImages";
import ConstantsTexts from "../../constants/ConstantsTexts";
import { DivColumn, DivRow, WidgetMarginWidth, ParagraphText } from "../../styles/SharedStyles";
import WidgetFilterDropdowns from "../../widgets/dropdowns/widget-filter-dropdowns/WidgetFilterDropdowns";
import WidgetMarkersMap from "../../widgets/maps/widget-markers-map/WidgetMarkersMap";
import UtilsUnit from "../../utils/UtilsUnit";
import WidgetModelIcon from "../../widgets/shared_widgets/widget-model-icon/WidgetModelIcon";
import WidgetDashboardIcon from "../../widgets/shared_widgets/widget-dashboard-icon/WidgetDashboardIcon";
import WidgetIconFive from "../../widgets/icons/widget-icon-five/WidgetIconFive";
import WidgetCreateTerminalIcon from "../../widgets/shared_widgets/widget-create-terminal-icon/WidgetCreateTerminalIcon";
import WidgetUsersIcon from "../../widgets/shared_widgets/widget-users-icon/WidgetUsersIcon";
import WidgetChangeRequestsIcon from "../../widgets/shared_widgets/widget-change-requests-icon/WidgetChangeRequestsIcon";

// CSS/Stylesheets
import "./PageFilter.css";

function PageFilter() {
  const {
    dataIsReceived,
    uniqueDistricts,
    handleSelectDropdownDistrict,
    selectedDistrict,
    uniqueMunicipalities,
    handleSelectDropdownMunicipality,
    selectedMunicipality,
    uniqueTerminals,
    handleSelectDropdownTerminal,
    selectedTerminal,
    mapMarkers,
    userData,
    navigate,
    hasActiveFilters,
  } = usePageFilter();

  if (!dataIsReceived) {
    return <div />;
  }

  return body();

  function body() {
    return (
      <div className="page-filter-container">
        <div style={{ width: "225rem" }}>
          <DivRow>
            {searchTerminalUi()}
            <WidgetMarginWidth width="3.3rem" />
            {mapUi()}
          </DivRow>
        </div>
      </div>
    );
  }

  function searchTerminalUi() {
    return (
      <DivColumn className="filter-frame-1" style={{ display: "inline-flex" }}>
        {titleUi()}
        <DivRow>
          {rightDesignUi()}
          <WidgetMarginWidth width="5.1rem" />
          {searchDropdownsUi()}
        </DivRow>
      </DivColumn>
    );
  }

  function titleUi() {
    return (
      <DivRow style={{ alignItems: "center" }}>
        <WidgetIconFive iconProp={ConstantsImages.TRANSPORTATION_IMAGE} widthIconProp="8.5rem" heightIconProp="17.2rem" />
        <WidgetMarginWidth width="1rem" />
        <ParagraphText className="model-text">{ConstantsTexts.CODE_1}</ParagraphText>
      </DivRow>
    );
  }

  function rightDesignUi() {
    return (
      <DivColumn className="filter-frame-3">
        <WidgetModelIcon userData={userData} />
        <WidgetDashboardIcon />
        {UtilsUnit.managerUser(userData) && <WidgetCreateTerminalIcon />}
        {UtilsUnit.managerUser(userData) && <WidgetUsersIcon />}
        {UtilsUnit.managerUser(userData) && <WidgetChangeRequestsIcon />}
      </DivColumn>
    );
  }

  // Renders search dropdowns with cascading filter functionality and navigation to terminal info
  function searchDropdownsUi() {
    return (
      <DivColumn className="filter-frame-2">
        <ParagraphText className="search-terminal-text">{ConstantsTexts.CODE_2}</ParagraphText>
        <WidgetFilterDropdowns
          uniqueDistricts={uniqueDistricts}
          uniqueMunicipalities={uniqueMunicipalities}
          uniqueTerminals={uniqueTerminals}
          selectedDistrict={selectedDistrict}
          selectedMunicipality={selectedMunicipality}
          selectedTerminal={selectedTerminal}
          handleSelectDropdownDistrict={handleSelectDropdownDistrict}
          handleSelectDropdownMunicipality={handleSelectDropdownMunicipality}
          handleSelectDropdownTerminal={handleSelectDropdownTerminal}
          handleSearchFrameClick={() => UtilsUnit.handleSearchFrameClick(navigate, selectedTerminal)}
        />
      </DivColumn>
    );
  }

  function mapUi() {
    return (
      <WidgetMarkersMap
        centerProp={UtilsUnit.getCenterPropForMap()}
        heightProp="88.6rem"
        widthProp="137rem" // 127rem
        markers={mapMarkers}
        hasActiveFilters={hasActiveFilters}
        showPinMarkers={false}
      />
    );
  }
}

export default PageFilter;
